export default async function profile({next, app}){
  let c = app.config.globalProperties;

  // Check if state dont have
  if (c.$store.state.auth.token && !c.$store.state.auth.user) {
    // Load profile
    let res = await c.$api.auth.profile().call();

    if (res.success) {
      c.$store.dispatch('auth/login', {
        user: res.response.user_info,
        pages: res.response.pages
      });
    }
  }

  next();
};